import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useVehicles } from '../contexts/VehiclesContext';
import { SPREADSHEET_URL } from '../utils/sheets';

/**
 * Aviso interno: aparece solo cuando la planilla no pudo leerse y el sitio está
 * mostrando el catálogo de demostración. Incluye el motivo exacto para poder
 * corregir el permiso o el nombre de la hoja.
 */
export function CatalogSourceNotice() {
  const {
    loading,
    source,
    error
  } = useVehicles();
  if (loading || source !== 'local') return null;
  return <div role="status" className="mb-6 flex gap-3 rounded-2xl border border-amber-400/40 bg-amber-400/10 p-4" data-id="element-67" data-mp="146qpq0oggiel">
      <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" aria-hidden="true" data-id="element-68" data-mp="1i114bp6qmw6x" />
      <div className="text-[13.5px] leading-relaxed text-amber-100" data-id="element-69" data-mp="1rx480zh8n2vz">
        <p className="font-semibold text-amber-200" data-id="element-70" data-mp="1rxdwujqjr403">
          Mostrando el catálogo de demostración
        </p>
        <p className="mt-1" data-id="element-71" data-mp="1mvx1t4uqubrf">
          No se pudo leer la hoja <strong data-id="element-72" data-mp="1om7c72cg2zmg">Vehículos</strong> de la planilla. Revisá que
          esté compartida como “Cualquier persona con el enlace · Lector” y que la
          pestaña se llame <strong data-id="element-73" data-mp="1yjd76lo6jary">Vehículos</strong>.
        </p>
        {error ? <p className="mt-1 text-amber-200/80" data-id="element-74" data-mp="1yi23smync51d">Detalle técnico: {error}</p> : null}
        <a href={SPREADSHEET_URL} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block font-semibold text-white underline underline-offset-2" data-id="element-75" data-mp="22m9sik53tkzl">
          Abrir la planilla
        </a>
      </div>
    </div>;
}